// Required to use TextDecoder in TS <2.8
// See https://stackoverflow.com/a/53429453
declare var TextDecoder: any;

import { Component, OnDestroy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jhi-alert-error',
    template: `
        <div class="alerts" role="alert">
            <div
                *ngFor="let alert of alerts"
                [ngClass]="{ 'alert.position': true, toast: alert.toast }"
            >
                <ngb-alert type="{{ alert.type }}" close="alert.close(alerts)">
                    <p [innerHTML]="alert.msg"></p>
                </ngb-alert>
            </div>
        </div>
    `,
})
export class JhiAlertErrorComponent implements OnDestroy {
    alerts: any[];
    cleanHttpErrorListener: Subscription;

    constructor(
        private alertService: JhiAlertService,
        private eventManager: JhiEventManager,
        private translateService: TranslateService
    ) {
        this.alerts = [];

        this.cleanHttpErrorListener = eventManager.subscribe(
            'platonApp.httpError',
            (response) => {
                let i: number;
                let httpResponse = response.content;
                if (httpResponse.error instanceof ArrayBuffer) {
                    // The error is occurring on an HTTP call that was made with the Angular HTTP client and
                    // "responseType: 'arraybuffer'" in the options, so even if the server responds with a JSON error,
                    // Angular gives it back to us as ArrayBuffer, that we need to convert to JSON.
                    // See https://github.com/angular/angular/issues/19888
                    httpResponse.error = JSON.parse(
                        new TextDecoder().decode(
                            new Uint8Array(httpResponse.error)
                        )
                    );
                }
                switch (httpResponse.status) {
                    // status 0 means connection refused, server not reachable
                    case 0:
                        this.addErrorAlert(
                            'Server not reachable',
                            'global.error.server.not.reachable'
                        );
                        break;

                    case 200:
                        // A GraphQL error
                        const message = httpResponse.body.errors
                            .map(
                                (error) =>
                                    `${error.message} at ${error.extensions.path} (${error.extensions.code})`
                            )
                            .join(', ');
                        this.addErrorAlert(
                            null,
                            'global.error.internalServerError',
                            { message: `GraphQL error(s): ${message}` }
                        );
                        break;

                    case 400:
                        if (httpResponse.error && httpResponse.error.errors) {
                            const message = httpResponse.error.errors
                                .map(
                                    (error) =>
                                        `${error.field} ${error.defaultMessage}`
                                )
                                .join(', ');
                            this.addErrorAlert(
                                null,
                                'global.error.genericClientError',
                                { message }
                            );
                        } else if (
                            httpResponse.error &&
                            httpResponse.error.message
                        ) {
                            this.addErrorAlert(
                                null,
                                'global.error.genericClientError',
                                httpResponse.error
                            );
                        } else {
                            this.addErrorAlert(
                                null,
                                'global.error.genericClientError',
                                { message: httpResponse.statusText }
                            );
                        }
                        break;

                    case 401:
                        this.addErrorAlert(
                            httpResponse.error.message,
                            'global.error.unauthorized'
                        );
                        break;

                    case 404:
                        this.addErrorAlert(
                            'Not found',
                            'global.error.url.not.found'
                        );
                        break;

                    default:
                        try {
                            if (
                                httpResponse.error &&
                                httpResponse.error.message
                            ) {
                                this.addErrorAlert(
                                    null,
                                    'global.error.internalServerError',
                                    httpResponse.error
                                );
                            } else {
                                this.addErrorAlert(
                                    null,
                                    'global.error.internalServerError',
                                    { message: httpResponse.statusText }
                                );
                            }
                        } catch (err) {
                            console.error(err);
                            this.addErrorAlert(
                                null,
                                'global.error.internalServerError',
                                {
                                    message:
                                        'could not extract error from response, this might be a binary response',
                                }
                            );
                        }
                }
            }
        );
    }

    ngOnDestroy() {
        if (
            this.cleanHttpErrorListener !== undefined &&
            this.cleanHttpErrorListener !== null
        ) {
            this.eventManager.destroy(this.cleanHttpErrorListener);
            this.alerts = [];
        }
    }

    addErrorAlert(message, key?, data?) {
        key = key || message;
        this.alerts.push(
            this.alertService.addAlert(
                {
                    type: 'danger',
                    msg: key,
                    params: data,
                    timeout: 10000,
                    toast: this.alertService.isToast(),
                    scoped: true,
                },
                this.alerts
            )
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/alert/alert-error.component.ts